export default class ConfigModel {
    api
    constructor() {
        this.api = "https://devadmin.stogoworld.com/api/"
        // this.api = "http://localhost:9000/api/"
        this.couponURL = "https://devverify.stogoworld.com"
    }
}
